/**
 * @generated SignedSource<<7f2ee7f76b0ff8fe5aa720b2c6b598f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RestoreNovaAgentVersionInput = {
  id: string;
  versionNumber: number;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type RestoreNovaAgentVersionMutation$variables = {
  input: RestoreNovaAgentVersionInput;
};
export type RestoreNovaAgentVersionMutation$data = {
  readonly restoreNovaAgentVersion: {
    readonly agent: {
      readonly id: string;
    } | null;
  } | null;
};
export type RestoreNovaAgentVersionMutation = {
  variables: RestoreNovaAgentVersionMutation$variables;
  response: RestoreNovaAgentVersionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RestoreNovaAgentVersionPayload",
    "kind": "LinkedField",
    "name": "restoreNovaAgentVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaAgent",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RestoreNovaAgentVersionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RestoreNovaAgentVersionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8b2d07961d9e8ee78cff540d467f6db5",
    "id": null,
    "metadata": {},
    "name": "RestoreNovaAgentVersionMutation",
    "operationKind": "mutation",
    "text": "mutation RestoreNovaAgentVersionMutation(\n  $input: RestoreNovaAgentVersionInput!\n) {\n  restoreNovaAgentVersion(input: $input) {\n    agent {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f05dba5ceb9dc828215e23261ed3bc01";

export default node;
